import 'css-chunksrc/client/common/popup/styles.scss';export default {
  "popup": "_popup_1t1m9_1"
};